// -----------------------------------------------------------------------------
// Upload file to server
// -----------------------------------------------------------------------------

// Dependencies
import axios from './axios'
import base64ToBlob from '@/components/DynamicForm/util/base64ToBlob'
import { getCompanyId } from '@/utils/getCompanyId'

// Types //
interface UploadParams {
	file: any
	fileName: string
	folderName: string
}

// Upload file to server
const upload = async ({ file, fileName, folderName }: UploadParams): Promise<string | null> => {
	const companyId = getCompanyId()

	return new Promise(async (resolve, reject) => {
		try {
			// detect base64 or real file
			const isBase64 =
				typeof file === 'string' &&
				(file.startsWith('data:') || /^[A-Za-z0-9+/=]+$/.test(file))

			const fileInput = isBase64 ? base64ToBlob(file, fileName) : file

			const response: any = await axios(
				'/assets/file',
				'POST',
				{
					company_id: companyId,
					folder_name: folderName,
					file_name: fileName,
					file_input: fileInput,
				},
				'multipart/form-data',
				false,
			)

			resolve(response.data?.url ?? response.url)
		} catch (error) {
			console.error('Upload failed:', error)
			reject(error)
		}
	})
}

export default upload